import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

interface HistoryPreviewSkeletonProps {
  /** Number of shimmer rows to render (default 3). */
  count?: number;
}

export function HistoryPreviewSkeleton({
  count = 3,
}: HistoryPreviewSkeletonProps): React.ReactElement {
  return (
    <Stack spacing={1.5}>
      {/* Section heading shimmer */}
      <Skeleton variant="text" width={160} height={28} animation="wave" />
      {Array.from({ length: count }).map((_, i) => (
        <Box
          key={i}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            p: 2,
            bgcolor: 'background.paper',
            borderRadius: '14px',
            boxShadow: '0 1px 8px rgba(0,0,0,0.03)',
          }}
        >
          {/* Icon circle */}
          <Skeleton variant="rounded" width={40} height={40} animation="wave" />
          {/* Text lines */}
          <Stack sx={{ flex: 1, gap: 0.5 }}>
            <Skeleton variant="text" width="70%" height={18} animation="wave" />
            <Skeleton variant="text" width="50%" height={14} animation="wave" />
            <Skeleton variant="text" width="40%" height={14} animation="wave" />
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}
